import axios from "axios";
import {getConfig} from "./utility";

const initialState = {
    selections: [],
    selectionDetails: [],
    fetchingSelections: false,
    fetchingSingle: false
};

const SELECTIONS_FETCH = "SELECTIONS_FETCH";
const SEARCH = "SEARCH_SELECTION";
const SELECTION_FIND = "SELECTION_FIND";


export default (state = initialState, action) => {
    switch (action.type) {
        case SELECTIONS_FETCH:
            switch (action.status) {
                case 0:
                    return {...state, fetchingSelections: true};
                case 1:
                    return {...state, selections: action.selections, fetchingSelections: false};
                default:
                    return {...state, fetchingSelections: false}
            }
        case SELECTION_FIND:
            switch (action.status) {
                case 0:
                    return {...state, fetchingSingle: true};
                case 1:
                    return {...state, selectionDetails: action.selectionDetails, fetchingSingle: false};
                default:
                    return {...state, fetchingSingle: false}
            }
        case SEARCH:
            switch (action.status) {
                case 0:
                    return {...state, fetchingSelections: true};
                case 1:
                    return {...state, selections: action.selections, fetchingSelections: false};
                default:
                    return {...state, fetchingSelections: false}
            }
        default:
            return state

    }
}


const getSelectionReq = () => ({type: SELECTIONS_FETCH, status: 0});
const getSelectionSuc = selections => ({type: SELECTIONS_FETCH, status: 1, selections});
const getSelectionErr = error => ({type: SELECTIONS_FETCH, status: -1, error});
export const getSelections = () => (dispatch, getState) => {
    dispatch(getSelectionReq());
    return axios.get('/selection', getConfig(getState))
        .then(res => dispatch(getSelectionSuc(res.data)))
        .catch(err => dispatch(getSelectionErr(err)))
};

/**
 * Get detailed selection
 */
const getSelectionsReq = (id) => ({type: SELECTION_FIND, status: 0, id});
const getSelectionsRec = selectionDetails => ({type: SELECTION_FIND, status: 1, selectionDetails});
const getSelectionsErr = error => ({type: SELECTION_FIND, status: -1, error});
export const findSelection = (id) => (dispatch, getState) => {
    dispatch(getSelectionsReq(id));
    return axios.get(`/selection/${id}`, getConfig(getState))
        .then(res => dispatch(getSelectionsRec(res.data)))
        .catch(err => dispatch(getSelectionsErr(err)))
};

const searchReq = request => ({type: SEARCH, status: 0, request});
const searchSuc = selections => ({type: SEARCH, status: 1, selections});
const searchErr = error => ({type: SEARCH, status: -1, error});
export const search = (request) => (dispatch, getState) => {
    dispatch(searchReq(request));
    return axios.post('/selection/search', request, getConfig(getState))
        .then(res => dispatch(searchSuc(res.data)))
        .catch(err => dispatch(searchErr(err)))
};






// WEBPACK FOOTER //
// ./src/js/reducers/selection.js